import React from 'react';
import style from './style';
import i18next from 'i18next';
import clsx from 'clsx';
import { FormGroup, FormLabel, TextField } from '@mui/material';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import EADatePicker from '../../../../../components/common/EADatePicker';
import Attribute from '../../../../Context/AddContext/steps/ContextAttributes/Attribute';

const NewContext = () => {
  const { classes } = style();
  const { control,watch } = useFormContext();
  const formMethods = useFormContext();
  const selectedContextModel = watch('modelNewContext');
  const contextAttributesValues = watch(`context.contextAttributes`);

  const {
    append: appendContextAttribute,
    remove: removeContextAttribute,
  } = useFieldArray({
    control,
    name: `context.contextAttributes`,
  });

  const setContextAttributes = (attribute) => {
    const currentAttributes = watch('contextAttributes') || [];
    const index = currentAttributes.findIndex(
      (attr) => attr.label === attribute.label
    );
    if (index !== -1) {
      removeContextAttribute(index);
      appendContextAttribute(attribute);
    } else {
      appendContextAttribute(attribute);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {i18next.t('thirdpartySheet.contextTp.selectedNewContextDetails')}
      </div>
      <div className={classes.firstBlock}>
        <div className={clsx(classes.inputWrapper, classes.item)}>
          <FormLabel className={classes.formLabel}>
            {`${i18next.t('context.creationInstance.reference')} * `}
          </FormLabel>
          <FormGroup>
            <Controller
              control={control}
              name={`context.reference`}
              rules={{
                required: i18next.t('infos.required'),
                validate: (value) => {
                  if (value.length > 100) {
                    return i18next.t(
                      'demandes.contextModel.creationForm.config.labelLengthError'
                    );
                  }
                  return true;
                },
              }}
              render={({ field }) => (
                <TextField
                  id="reference"
                  className={clsx(classes.textField)}
                  placeholder={i18next.t(
                    'demandes.contextModel.creationForm.config.placeholder.modelLabel'
                  )}
                  variant="outlined"
                  fullWidth
                  {...field}
                />
              )}
            />
          </FormGroup>
        </div>
        <div className={clsx(classes.inputWrapper, classes.item)}>
          <FormLabel className={classes.formLabel}>
            {`${i18next.t('context.creationInstance.expirationDate')} * `}
          </FormLabel>
          <FormGroup>
            <Controller
              control={control}
              name={`context.expirationDate`}
              render={({ field }) => (
                <EADatePicker
                  {...field}
                  formMethods={formMethods}
                  onlyDate
                  sxClass={{
                    marginTop: '8px',
                    background: 'white'
                  }}
                  onError={() => {}}
                  ref={null}
                />
              )}
            />
          </FormGroup>
        </div>
      </div>
      <div className={clsx(classes.item)}>
        <FormLabel className={classes.formLabel}>
          {`${i18next.t('context.creationInstance.description')} * `}
        </FormLabel>
        <FormGroup>
          <Controller
            control={control}
            name={`context.description`}
            rules={{
              required: i18next.t('infos.required'),
              validate: (value) => {
                if (value.length > 100) {
                  return i18next.t(
                    'demandes.contextModel.creationForm.config.labelLengthError'
                  );
                }
                return true;
              },
            }}
            render={({ field }) => (
              <TextField
                id="name"
                className={clsx(classes.textField)}
                placeholder={i18next.t(
                  'demandes.contextModel.creationForm.config.placeholder.modelLabel'
                )}
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                {...field}
              />
            )}
          />
        </FormGroup>
      </div>
      {selectedContextModel ? (
        <div className={classes.attributeList}>
          <div className={classes.attributeListHeader}>
            <span className={classes.attributeListHeaderTitle}>
              {i18next.t(`context.addContextInstance`)}
            </span>
          </div>
          <div className={classes.attributeListContent}>
            {selectedContextModel.contextAttributes.map((contextAttribute) => (
              <div key={contextAttribute.id}>
                <Attribute
                  contexteAttribute={contextAttribute}
                  onValidateSuccess={setContextAttributes}
                  currentValue={contextAttributesValues.find(
                    (c) => c.label === contextAttribute.label
                  )}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        ''
      )}

    </div>
  );
};

export default NewContext;
